import React from 'react';
import { Flex, Text } from '@mafc/trolly';
import { useTranslation } from 'react-i18next';
import EasyPaisaIcon from 'assets/svgs/EasyPaisa';
import COLORS from 'theme/colors';

const EasyPaisaTag = () => {
  const { t } = useTranslation();

  return (
    <Flex>
      <EasyPaisaIcon />
      <Text paddingLeft={2} fontWeight={8} color={COLORS.BLACK}>
        {t('easyPaisa.paymentTitle')}
      </Text>
    </Flex>
  );
};
export default EasyPaisaTag;
